import {MetaTags} from '@frontend/components/MetaTags'
import {ResponsiveLayout} from '@frontend/components/ResponsiveLayout'
import {trans} from '@frontend/helpers'
import {useConfigureUi} from '@frontend/hooks/useConfigureUi'
import {PromoCards} from '@frontend/modules/layout/promo_cards/PromoCards'
import type {FilteredItemsListPageHeaderInfo} from '@frontend/modules/public/ads/AdsModuleTypes'
import {AdsOrServicesBreadcrumbs} from '@frontend/modules/public/ads/components/AdsOrServicesBreadcrumbs'
import {AdsCategoryFiltersPanelMobile} from '@frontend/modules/public/ads/components/category_filters/AdsCategoryFiltersPanelMobile'
import {AdsCategoryFiltersPanelTabletAndDesktop} from '@frontend/modules/public/ads/components/category_filters/AdsCategoryFiltersPanelTabletAndDesktop'
import {useInitFilteredItemsPage} from '@frontend/modules/public/ads/hooks/useInitFilteredItemsPage'
import {FilteredServicesList} from '@frontend/modules/public/services/components/list/FilteredServicesList'
import clsx from 'clsx'
import {useState} from 'react'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {Badge} from 'swayok-react-mdb-ui-kit/components/Typography/Badge'

// Страница со списком услуг и дополнительной фильтрацией.
export default function ServicesPage() {

    const [
        pageHeaderInfo,
        setPageHeaderInfo,
    ] = useState<FilteredItemsListPageHeaderInfo>(() => ({
        header: '',
        totalItemsCount: 0,
        categoriesPath: [],
        isLoadedOnce: false,
    }))

    const {
        header,
        categoriesPath,
        totalItemsCount,
        isLoadedOnce,
    } = pageHeaderInfo

    // Настройка глобальных элементов интерфейса приложения.
    useConfigureUi(config => {
        config.topMenu.wrapInCard = true
        config.topMenu.stickToTop = true
        return config
    })

    // Инициализация страницы поиска объявлений.
    const isReady = useInitFilteredItemsPage()

    if (!isReady) {
        return null
    }

    return (
        <div className="container-fluid container-xl">
            <div className="flex-container-row pb-4">
                <div className="flex-1">
                    <div>
                        {categoriesPath.length > 0 && (
                            <Collapse show={true}>
                                <AdsOrServicesBreadcrumbs
                                    path={categoriesPath}
                                    className="mb-3"
                                />
                            </Collapse>
                        )}
                        {header.length > 0 && (
                            <MetaTags
                                title={header}
                                wrapTitle
                            />
                        )}
                        {header.length > 0 && (
                            <Collapse show={true}>
                                <div
                                    className={clsx(
                                        'd-flex flex-column align-items-stretch justify-content-start',
                                        'flex-md-row align-items-md-center'
                                    )}
                                >
                                    <div className="flex-1 d-flex flex-row align-items-center justify-content-between">
                                        <div className="d-flex flex-row align-items-center justify-content-start">
                                            <h1 className="my-0 offered-items-list-page-header">
                                                {header}
                                            </h1>
                                            <Badge
                                                pill
                                                color="red"
                                                className="ms-3 fs-6 fw-400 align-middle d-inline-block"
                                            >
                                                {totalItemsCount}
                                            </Badge>
                                        </div>
                                        <AdsCategoryFiltersPanelMobile services />
                                    </div>
                                </div>
                            </Collapse>
                        )}
                    </div>
                    <div className="flex-container-row mt-3 mt-sm-4">
                        {isLoadedOnce && (
                            <AdsCategoryFiltersPanelTabletAndDesktop services />
                        )}
                        <FilteredServicesList
                            setPageHeaderInfo={setPageHeaderInfo}
                        />
                    </div>
                    <ResponsiveLayout
                        desktop={null}
                        wideTablet={
                            <div className="promo-cards-block-standalone">
                                <div className="mt-4 fw-500 fs-5">
                                    {trans().ads.list.features}:
                                </div>
                                <PromoCards
                                    className="mt-4 grid-columns-md-2"
                                    utmSource="services_search_page"
                                />
                            </div>
                        }
                        mobile={
                            <PromoCards
                                className="mt-4 promo-cards-block-standalone"
                                utmSource="services_search_page"
                            />
                        }
                    />
                </div>
            </div>
        </div>
    )
}
